import apiClient from './client';

export interface Crew {
  id: number;
  name: string;
  lead_id?: number;
  leadId?: number;
  lead_name?: string;
  leadName?: string;
  status: 'Available' | 'On Job' | 'Off Duty';
  member_count?: number;
  memberCount?: number;
  members?: CrewMember[];
  created_at?: string;
  updated_at?: string;
}

export interface CrewMember {
  id: number;
  name: string;
  role: string;
}

export interface CrewCapacity {
  availableHours: number;
  scheduledHours: number;
  utilization: number;
  overtime: number;
}

export const getCrews = async (): Promise<Crew[]> => {
  const response = await apiClient.get('/crews');
  return response.data.data;
};

export const getCrew = async (id: number): Promise<Crew> => {
  const response = await apiClient.get(`/crews/${id}`);
  return response.data.data;
};

export const createCrew = async (data: {
  name: string;
  leadId?: number;
  status?: string;
  members?: number[];
}): Promise<Crew> => {
  const response = await apiClient.post('/crews', data);
  return response.data.data;
};

export const updateCrew = async (
  id: number,
  data: {
    name?: string;
    leadId?: number;
    status?: string;
    members?: number[];
  }
): Promise<void> => {
  await apiClient.put(`/crews/${id}`, data);
};

export const deleteCrew = async (id: number): Promise<void> => {
  await apiClient.delete(`/crews/${id}`);
};

export const getCrewCapacity = async (
  id: number,
  startDate: string,
  endDate: string
): Promise<CrewCapacity> => {
  const response = await apiClient.get(`/crews/${id}/capacity`, {
    params: { startDate, endDate },
  });
  return response.data.data;
};
